<div class="toast-container" aria-live="assertive" aria-atomic="true" role="alert">
  @for (toast of toasts$ | async; track toast.id) {
    <div
      class="toast"
      [class.toast--success]="toast.severity === 'success'"
      [class.toast--error]="toast.severity === 'error'"
      [class.toast--warning]="toast.severity === 'warning'"
      [class.toast--info]="toast.severity === 'info'"
      role="alert"
      [attr.aria-label]="toast.severity + ': ' + toast.message"
    >
      <div class="toast__content">
        <mat-icon class="toast__icon" aria-hidden="true">{{ getIcon(toast.severity) }}</mat-icon>
        <span class="toast__message">{{ toast.message }}</span>
      </div>
      <div class="toast__actions">
        @if (toast.options.retry) {
          <button
            mat-button
            class="toast__retry-btn"
            (click)="onRetry(toast)"
            aria-label="Retry action"
          >
            Retry
          </button>
        }
        <button
          mat-icon-button
          class="toast__close-btn"
          (click)="dismiss(toast.id)"
          aria-label="Dismiss notification"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  }
</div>
